<template>
  <div>
    <es-loader v-if="loading" style="margin: 6.5rem"/>
    <es-exception v-else-if="!loading && loadingError"
      exceptionMessage="There was an issue. Please try again or contact your administrator."
    />
    <div v-else>
      <es-profile-header>
        <template #profile-header>
          <div class="columns">
            <div class="column">
              <div class="column-content">
                <div class="header-title">
                  {{location.name}}
                </div>
                <div class="header-subtitle">
                  {{location.street1 === undefined ? '' : `${location.street1}, `}}
                  {{location.street2 === undefined ? '' : `${location.street2}, `}}
                </div>
                <div class="header-subtitle">
                  {{location.city === undefined ? '' : `${location.city}, `}}
                  {{location.stateCode === undefined ? '' : `${location.stateCode}, `}}
                  {{location.zip === undefined ? '' : `${maskZip(location.zip)}`}}
                </div>
              </div>
            </div>
            <div class="column is-flex flex-justify--center flex-align--center">
              <div class="column-content">
                <div class="header-subtitle is-flex flex-align--center">
                  <font-awesome-icon :icon="['fas', 'envelope']" size="1x"/>
                  <span v-if="location.adminEmail" class="padding--left">
                    {{location.adminEmail}}
                  </span>
                  <span v-else class="padding--left">N/A</span>
                </div>
                <div class="header-subtitle">
                  <font-awesome-icon :icon="['fas', 'phone']" size="1x"/>
                  <span v-if="location.adminPhone" class="padding--left">
                    {{location.adminPhone}}
                  </span>
                  <span v-else class="padding--left">N/A</span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template #profile-overview>
          <div class="columns">
            <div class="column">
              <div class="column-content">
                <div class="column-title">{{ activeStatus }}</div>
                <div class="column-subtitle">Status</div>
              </div>
            </div>
            <div class="column">
              <div class="column-content">
                <div class="column-title">
                  {{location.startDate | formatDateMMDDYYYY }}
                </div>
                <div class="column-subtitle">Start Date</div>
              </div>
            </div>
            <div class="column">
              <div class="column-content">
                <div class="column-title">
                  {{location.endDate | formatDateMMDDYYYY }}
                </div>
                <div class="column-subtitle">End Date</div>
              </div>
            </div>
          </div>
        </template>
      </es-profile-header>
      <div class="tabs-container">
        <div class="tabs no-bottom-border">
          <ul>
            <li :class="{ 'is-active': this.$route.name === 'directMatchLocationDetails' }">
              <router-link :to="{ name: 'directMatchLocationDetails'}">
                DETAILS
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <router-view :location="location"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import moment from 'moment';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEnvelope,
  faPhone,
} from '@fortawesome/pro-solid-svg-icons';

import EsException from '@/components/EsException.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsProfileHeader from '@/components/EsProfileHeader.vue';

import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import ZipUtils from '@/mixins/ZipUtils';

library.add(
  faEnvelope,
  faPhone,
);

export default {
  mixins: [
    BreadcrumbsManager,
    ZipUtils
  ],
  components: {
    EsException,
    EsLoader,
    EsProfileHeader,
  },
  props: {
    id: {
      type: String,
      requred: true,
    },
  },
  data() {
    return {
      loading: true,
      loadingError: null,
      location: {},
    };
  },
  created() {
    this.onLoad();

    this.setBreadcrumb([
      { text: 'Home', to: { name: 'directMatch' } },
      { text: 'Location Profile', to: {} },
    ]);
  },
  computed: {
    activeStatus() {
      return this.location.active ? 'Active' : 'Inactive';
    },
  },
  methods: {
    ...mapActions([
      'getLocation',
    ]),
    async onLoad() {
      try {
        this.loading = true;
        this.loadingError = false;

        const response = await this.getLocation(this.id);
        this.location = response.data;
      } catch (e) {
        this.loadingError = true;
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>

<style lang="sass" scoped>
  .padding--left
    padding-left: 1rem
</style>
